// src/utils/auth.js
import axios from "axios";
export const setToken = (token) => {
  localStorage.setItem("token", token);
  // Set default Authorization header for axios
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const removeToken = () => {
  localStorage.removeItem("token");
};

export const setUser = (user) => {
  try {
    localStorage.setItem("user", JSON.stringify(user));
    // notify other tabs
    window.dispatchEvent(new Event('user_changed'));
  } catch (e) {
    console.error('setUser error', e);
  }
};

export const getUser = () => {
  try {
    const v = localStorage.getItem("user");
    return v ? JSON.parse(v) : null;
  } catch (e) {
    return null;
  }
};

export const removeUser = () => {
  localStorage.removeItem("user");
  window.dispatchEvent(new Event('user_changed'));
};

// AIAdmin, MagicWriterAdmin, WhatsappAdmin use this
export const toNumber = (val, fallback = 0) =>
  val === "" || val === null || val === undefined ? fallback : Number(val);

export const safeJSONParse = (str, fallback = {}) => {
  try {
    return str ? JSON.parse(str) : fallback;
  } catch {
    return fallback;
  }
};
// End AIAdmin, MagicWriterAdmin, WhatsappAdmin use this


